import { render, staticRenderFns } from "./adminPerformance.vue?vue&type=template&id=5e007255&scoped=true"
import script from "./adminPerformance.js?vue&type=script&lang=js&external"
export * from "./adminPerformance.js?vue&type=script&lang=js&external"
import style0 from "./adminPerformance.less?vue&type=style&index=0&id=5e007255&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e007255",
  null
  
)

export default component.exports